import {blobToDataURL, cloneCanvas, addCanvasWebWorker} from "lib/helpers/common";

export class AutoVideEffect{
    opacity = 1;
    screenshot = false;
    screenshotCanvas = null;
    noImgSrc = 'https://www.eyespy360.com/common/images/no_img.png';

    constructor(details, frequency) {
        this.details = details;
        this.frequency = frequency;
    }

    updateCanvas(canvas){
        return new Promise(async (res, rej) => {
            try{
                if (this.screenshot) {
                    const webglCanvas = canvas.getContext("webgl").canvas;
                    this.screenshotCanvas = cloneCanvas(webglCanvas);
                }

                canvas = canvas.getContext("webgl").canvas;

                if (this.opacity < 1 && this.screenshotCanvas) {
                    canvas = await this.fadeEffect(canvas, this.screenshotCanvas, 1 - this.opacity);
                }

                if(!this.details.show) return res(canvas);

                canvas = await this.addDetails(canvas,
                    {details: `${this.details.full_name}  |  ${this.details.phone}  |  ${this.details.email}`, src: this.details.profile_url || this.noImgSrc},
                    canvas);

                res(canvas);
            }catch (e){
                rej(e);
            }
        })
    }

    addDetails = (canvas, {details, src}, original) => {
        return new Promise(async(res, rej) => {
            var my_canvas = document.createElement('canvas'),
                context = my_canvas.getContext("2d");

            // const background = await this.loadImg(base64);
            const width = canvas.width;
            const height = canvas.height;
            my_canvas.width = width;
            my_canvas.height = height;
            my_canvas.style.width = width;
            my_canvas.style.height = height;
            context.drawImage(canvas, 0, 0);

            const paddingContacts = 250;
            const area = {
                top: height-120,
                width: 120,
            }

            context.globalAlpha = 0.6
            context.fillStyle = "white";
            context.fillRect(0, area.top, original.width, area.width);
            context.globalAlpha = 1
            context.fillStyle = "#000";

            const contact = {
                top: height - 90,
                width: 60,
                message: details
            }
            context.fillStyle = "red";
            context.fillRect(0, contact.top, original.width, contact.width);

            context.font = "bold 24px Helvetica";
            context.fillStyle = "#fff";
            context.fillText(contact.message,  paddingContacts, contact.top + 40);

            const image = {
                height: 300,
                width: 30,
                top: area.top - 60,
                left: 80
            }
            function drawCycle(centerX, centerY){
                const radius = 75;
                context.beginPath();
                context.arc(centerX + 70, centerY +70, radius, 0, 2 * Math.PI, false);
                context.fillStyle = 'red';
                context.fill();
            }
            function roundedImage(ctx, x, y, width, height, radius) {
                ctx.beginPath();
                ctx.moveTo(x + radius, y);
                ctx.lineTo(x + width - radius, y);
                ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                ctx.lineTo(x + width, y + height - radius);
                ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                ctx.lineTo(x + radius, y + height);
                ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                ctx.lineTo(x, y + radius);
                ctx.quadraticCurveTo(x, y, x + radius, y);
                ctx.closePath();
            }

            const img = await this.loadImg(src);
            context.beginPath();
            drawCycle(image.left,image.top)
            context.beginPath();
            context.arc(image.left +70, image.top +70, 70, 0, Math.PI * 2, false)
            context.clip()
            context.drawImage(img, image.left, image.top , 140 , 140);
            res(my_canvas);
        })
    }

    loadImg(src) {
        return new Promise((res, rej) => {
            var image = new Image();
            image.onload = () => {
                res(image);
            }
            image.crossOrigin="anonymous";
            image.onerror = (err) => {
                res(err);
            }
            image.src = src;
        })
    }


    fadeEffect = (canvas, screenshotCanvas, opacity) =>  {
        return new Promise(async (res, rej) => {
            try {
                const canvasDest = document.createElement("canvas");
                const ctx = canvasDest.getContext('2d');
                ctx.fillStyle = "white";

                canvasDest.width = canvas.width;
                canvasDest.height = canvas.height;
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height);

                ctx.globalAlpha = opacity;
                ctx.drawImage(screenshotCanvas, 0, 0, canvas.width, canvas.height);

                res(canvasDest);
            } catch (e) {
                rej(e);
            }
        })
    }

    addCanvasOpacity(base64, opacity) {
        return new Promise((res, rej) => {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = "white";
            var image = new Image();
            image.onload = () => {
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;
                ctx.fillRect(0, 0, image.width, image.height);
                ctx.globalAlpha = opacity;
                ctx.drawImage(image, 0, 0, image.width, image.height);

                res(canvas);
            }
            image.src = base64;
        })
    }


    addOpacity(val) {
        this.opacity = val;
    }

    makeScreenshot = (commands, time, index) => {
        const state = commands[index];
        const nextState = commands[index + 1];

        if (nextState &&
            nextState.scene !== state.scene &&
            Math.abs(time - state.animation.end) <= this.frequency
        ) {
            // console.log('on change scene')
            this.screenshotCanvas = null;

            this.screenshot = true;

            return true
        }

        this.screenshot = false;

        return false;
    }

    addOpacityOnSceneChanges = (commands, time, index) => {
        const state = commands[index];
        const nextState = commands[index + 1];
        const prevState = commands[index - 1];
        const prevPrevState = commands[index - 2];

        // if (nextState &&
        //     nextState.scene !== state.scene &&
        //     Math.abs(time - state.animation.end) < this.frequency * 1.5
        // ) {
        //     // console.log('on change scene')
        // }

        if (nextState &&
            nextState.scene !== state.scene &&
            Math.abs(time - state.animation.end) < 1000
        ) {
            // console.log('fadeout 1000s before change scene')
            // fadeout 1000s before change scene
            // addOpacity(Math.abs(time - state.animation.end)/1000);
        } else if ((prevState &&
            prevState.scene !== state.scene) ||
            prevPrevState &&
            prevPrevState.scene !== state.scene
        ) {
            console.log('fadein after change scene')
            // fadein after change scene
            this.addOpacity((Math.abs(state.animation.start - time)) / 1000);
        }
    }


    hideFrame = (commands, index) => {
        const state = commands[index];
        const prevState = commands[index - 1];
        const prevPrevState = commands[index - 2];

        if (state && ((prevState && prevState.scene !== state.scene) ||
            (prevPrevState && prevPrevState.scene !== state.scene))
        ) {
            // console.log('===hideFrame===')
            this.addOpacity(0);
        }
    }

}



